import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TranslatePipe, TranslateModule} from 'ng2-translate';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule
  ],
  declarations: [],
  exports:[
    TranslatePipe,
  ]
})
export class AppTranslateModule { }



// WEBPACK FOOTER //
// ./src/app/core/translate/translate.module.ts